if (!customElements.get('gb-formula-guide')) {
  customElements.define('gb-formula-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const search = this.querySelector('[data-guide-search]');
      const input = this.querySelector('input[type="search"]');
      const cards = [...this.querySelectorAll('[data-pad-family]')];
      const status = this.querySelector('[data-guide-status]');
      const empty = this.querySelector('[data-guide-empty]');
      if (!search || !input || !cards.length || !status || !empty) return;
      const normalise = value => value.toLowerCase().normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\bformula\b/g, '')
        .replace(/[\u2010-\u2015\u2212]/g, '-')
        .replace(/\+/g, 'plus')
        .replace(/(\d)[\s-]*(?:pistons?|kolben|p)\b/g, '$1p')
        .replace(/[^a-z0-9]/g, '');
      const entries = cards.map(card => ({
        card,
        names: card.dataset.models.split('|').map(normalise),
        heading: normalise(card.querySelector('h3').textContent)
      }));
      const update = () => {
        const value = normalise(input.value);
        const hasExact = value && entries.some(entry => entry.names.includes(value));
        let count = 0;
        entries.forEach(({card, names, heading}) => {
          const matches = !value || (hasExact ? names.includes(value) : names.some(name => name.includes(value)) || heading.includes(value));
          card.hidden = !matches;
          if (matches) count++;
          card.querySelector('details').open = !!value && matches;
        });
        status.textContent = `${status.dataset.label} ${count} / ${cards.length}`;
        empty.hidden = count > 0;
      };
      input.addEventListener('input', update);
      this.querySelector('[data-guide-reset]').addEventListener('click', () => {
        input.value = '';
        update();
        input.focus();
      });
      this.querySelectorAll('[data-family-jump]').forEach(link => link.addEventListener('click', () => {
        if (input.value) {input.value = ''; update();}
      }));
      search.hidden = false;
      update();
    }
  });
}
